import axios from 'axios';
import { getToken } from './auth';

import { API_URL } from './config';

const withAuth = () => ({
  headers: { Authorization: `Bearer ${getToken()}` },
  withCredentials: true,
});

export const listPurchaseOrders = async (branchId, params = {}) =>
  (await axios.get(`${API_URL}/branch/${branchId}/purchase-orders`, { ...withAuth(), params })).data;

export const getPurchaseOrderById = async (branchId, id) =>
  (await axios.get(`${API_URL}/branch/${branchId}/purchase-orders/${id}`, withAuth())).data;

export const getPurchaseOrderCatalog = async (branchId, id) =>
  (await axios.get(`${API_URL}/branch/${branchId}/purchase-orders/${id}/catalog`, withAuth())).data;

export const getPurchaseOrderReasons = async (branchId) =>
  (await axios.get(`${API_URL}/branch/${branchId}/purchase-orders/reasons`, withAuth())).data;

export const updatePurchaseOrderStatus = async (branchId, id, status) =>
  (await axios.patch(`${API_URL}/branch/${branchId}/purchase-orders/${id}/status`, { status }, withAuth())).data;

export const updatePurchaseOrderDiscount = async (branchId, id, data) =>
  (await axios.patch(`${API_URL}/branch/${branchId}/purchase-orders/${id}/discount`, data || {}, withAuth())).data;

export const applyPurchaseOrderItemsDiscount = async (branchId, id, data) =>
  (await axios.patch(`${API_URL}/branch/${branchId}/purchase-orders/${id}/items/discount`, data || {}, withAuth())).data;

export const convertPurchaseOrderToSale = async (branchId, id) =>
  (await axios.post(`${API_URL}/branch/${branchId}/purchase-orders/${id}/convert-to-sale`, {}, withAuth())).data;

export const addPurchaseOrderItems = async (branchId, id, items) =>
  (await axios.post(`${API_URL}/branch/${branchId}/purchase-orders/${id}/items`, { items }, withAuth())).data;

export const updatePurchaseOrderItemConfirmation = async (branchId, id, itemId, data) =>
  (await axios.patch(
    `${API_URL}/branch/${branchId}/purchase-orders/${id}/items/${itemId}/confirmation`,
    data || {},
    withAuth()
  )).data;

export const updatePurchaseOrderItemAdjustment = async (branchId, id, itemId, data) =>
  (await axios.patch(
    `${API_URL}/branch/${branchId}/purchase-orders/${id}/items/${itemId}/adjustment`,
    data || {},
    withAuth()
  )).data;

export const updatePurchaseOrderItemDiscount = async (branchId, id, itemId, data) =>
  (await axios.patch(
    `${API_URL}/branch/${branchId}/purchase-orders/${id}/items/${itemId}/discount`,
    data || {},
    withAuth()
  )).data;
